/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayVolumeLimits_ConfigFragment = { __typename: 'ConfigurationModel', id: string, volume?: { __typename: 'ConfigVolume', limits?: { __typename: 'ConfigVolumeLimitState', min?: { __typename: 'VolumeLimit', reported: number } | null, max?: { __typename: 'VolumeLimit', reported: number } | null } | null } | null };

export type ConfigUpdateVolumeLimitMinMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateVolumeLimitMinInput;
}>;


export type ConfigUpdateVolumeLimitMinMutation = { __typename: 'Mutation', configurationUpdateVolumeLimitMin: { __typename: 'ConfigurationModel', id: string, volume?: { __typename: 'ConfigVolume', limits?: { __typename: 'ConfigVolumeLimitState', min?: { __typename: 'VolumeLimit', reported: number } | null, max?: { __typename: 'VolumeLimit', reported: number } | null } | null } | null } };

export type ConfigUpdateVolumeLimitMaxMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateVolumeLimitMaxInput;
}>;


export type ConfigUpdateVolumeLimitMaxMutation = { __typename: 'Mutation', configurationUpdateVolumeLimitMax: { __typename: 'ConfigurationModel', id: string, volume?: { __typename: 'ConfigVolume', limits?: { __typename: 'ConfigVolumeLimitState', min?: { __typename: 'VolumeLimit', reported: number } | null, max?: { __typename: 'VolumeLimit', reported: number } | null } | null } | null } };

export const ConfigDisplayVolumeLimits_ConfigFragmentDoc = gql`
    fragment ConfigDisplayVolumeLimits_config on ConfigurationModel {
  id
  volume {
    limits {
      min {
        reported
      }
      max {
        reported
      }
    }
  }
}
    `;
export const ConfigUpdateVolumeLimitMinDocument = gql`
    mutation ConfigUpdateVolumeLimitMin($input: ConfigurationUpdateVolumeLimitMinInput!) {
  configurationUpdateVolumeLimitMin(input: $input) {
    id
    ...ConfigDisplayVolumeLimits_config
  }
}
    ${ConfigDisplayVolumeLimits_ConfigFragmentDoc}`;
export type ConfigUpdateVolumeLimitMinMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateVolumeLimitMinMutation, ConfigUpdateVolumeLimitMinMutationVariables>;

/**
 * __useConfigUpdateVolumeLimitMinMutation__
 *
 * To run a mutation, you first call `useConfigUpdateVolumeLimitMinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateVolumeLimitMinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateVolumeLimitMinMutation, { data, loading, error }] = useConfigUpdateVolumeLimitMinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateVolumeLimitMinMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateVolumeLimitMinMutation, ConfigUpdateVolumeLimitMinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateVolumeLimitMinMutation, ConfigUpdateVolumeLimitMinMutationVariables>(ConfigUpdateVolumeLimitMinDocument, options);
      }
export type ConfigUpdateVolumeLimitMinMutationHookResult = ReturnType<typeof useConfigUpdateVolumeLimitMinMutation>;
export type ConfigUpdateVolumeLimitMinMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateVolumeLimitMinMutation>;
export type ConfigUpdateVolumeLimitMinMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateVolumeLimitMinMutation, ConfigUpdateVolumeLimitMinMutationVariables>;
export const ConfigUpdateVolumeLimitMaxDocument = gql`
    mutation ConfigUpdateVolumeLimitMax($input: ConfigurationUpdateVolumeLimitMaxInput!) {
  configurationUpdateVolumeLimitMax(input: $input) {
    id
    ...ConfigDisplayVolumeLimits_config
  }
}
    ${ConfigDisplayVolumeLimits_ConfigFragmentDoc}`;
export type ConfigUpdateVolumeLimitMaxMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateVolumeLimitMaxMutation, ConfigUpdateVolumeLimitMaxMutationVariables>;

/**
 * __useConfigUpdateVolumeLimitMaxMutation__
 *
 * To run a mutation, you first call `useConfigUpdateVolumeLimitMaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateVolumeLimitMaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateVolumeLimitMaxMutation, { data, loading, error }] = useConfigUpdateVolumeLimitMaxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateVolumeLimitMaxMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateVolumeLimitMaxMutation, ConfigUpdateVolumeLimitMaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateVolumeLimitMaxMutation, ConfigUpdateVolumeLimitMaxMutationVariables>(ConfigUpdateVolumeLimitMaxDocument, options);
      }
export type ConfigUpdateVolumeLimitMaxMutationHookResult = ReturnType<typeof useConfigUpdateVolumeLimitMaxMutation>;
export type ConfigUpdateVolumeLimitMaxMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateVolumeLimitMaxMutation>;
export type ConfigUpdateVolumeLimitMaxMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateVolumeLimitMaxMutation, ConfigUpdateVolumeLimitMaxMutationVariables>;